import { render } from "./Contacts.vue?vue&type=template&id=6579d112&scoped=true&lang=pug&bindings={\"num\":\"props\",\"link\":\"props\",\"text\":\"props\",\"color\":\"props\"}"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=6579d112&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-6579d112"

export default script